var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function hexString(buffer) {
    const byteArray = new Uint8Array(buffer);
    const hexCodes = [...byteArray].map(value => {
        return value.toString(16).padStart(2, "0");
    });
    return hexCodes.join("");
}
export function hashString(message) {
    return __awaiter(this, void 0, void 0, function* () {
        const encoder = new TextEncoder();
        const data = encoder.encode(message);
        const hash = yield crypto.subtle.digest("SHA-256", data);
        return hexString(hash);
    });
}
export const debug = process.env.NODE_ENV !== "production";
export function log(...args) {
    if (!debug)
        return;
    console.log("[CUSTOM COMPONENT]", ...args);
}
